import { ShoppingBag } from "lucide-react";
import { Drawer, DrawerContent, DrawerTitle } from "@/components/ui/drawer";
import { CartPanel } from "@/components/CartPanel";
import { useCart } from "@/context/CartContext";
import { rupiah } from "@/lib/api";

export const MobileCart = () => {
  const { count, total, sheetOpen, setSheetOpen, shop } = useCart();
  const withTax = total + Math.round((total * shop.taxRate) / 100);
  return (
    <>
      <div className="lg:hidden fixed bottom-0 inset-x-0 z-30 p-3 bg-gradient-to-t from-cream via-cream/95 to-transparent">
        <button onClick={() => setSheetOpen(true)} className="btn-forest w-full flex items-center justify-between px-5 py-4 shadow-lg" data-testid="mobile-cart-bar">
          <span className="flex items-center gap-2"><ShoppingBag className="w-5 h-5" /> {count} item</span>
          <span className="flex items-center gap-2">{rupiah(withTax)} <span className="opacity-80">· Lanjut</span></span>
        </button>
      </div>
      <Drawer open={sheetOpen} onOpenChange={setSheetOpen}>
        <DrawerContent className="bg-cream max-h-[92vh]" data-testid="mobile-cart-drawer">
          <DrawerTitle className="sr-only">Pesananmu</DrawerTitle>
          <div className="overflow-y-auto p-3 pb-6">{sheetOpen && <CartPanel />}</div>
        </DrawerContent>
      </Drawer>
    </>
  );
};
